const THINKING_EFFORT_MODELS = {
  'claude-sonnet-4-6': {
    supportsThinking: true,
    supportsEffort: true,
    thinkingDefault: 'off',
    effortLevels: ['low', 'medium', 'high', 'max'],
    defaultEffort: 'medium',
  },
  'claude-sonnet-5': {
    supportsThinking: true,
    supportsEffort: true,
    thinkingDefault: 'adaptive',
    effortLevels: ['low', 'medium', 'high', 'xhigh', 'max'],
    defaultEffort: 'high',
  },
  'claude-opus-5': {
    supportsThinking: true,
    supportsEffort: true,
    thinkingDefault: 'adaptive',
    effortLevels: ['low', 'medium', 'high', 'xhigh', 'max'],
    defaultEffort: 'high',
  },
};

export function getClassifierModelCapabilities(provider, model, catalogueEntry) {
  if (provider !== 'anthropic') {
    return {
      supportsThinking: false,
      supportsEffort: false,
      thinkingDefault: null,
      effortLevels: [],
      defaultEffort: null,
    };
  }

  const known = THINKING_EFFORT_MODELS[model];
  if (known) {
    return {...known};
  }

  if (catalogueEntry?.supportsThinking === true) {
    return {
      supportsThinking: true,
      supportsEffort: catalogueEntry.supportsEffort === true,
      thinkingDefault: catalogueEntry.thinkingDefault || 'off',
      effortLevels: Array.isArray(catalogueEntry.effortLevels)
        ? [...catalogueEntry.effortLevels]
        : [],
      defaultEffort: model === 'claude-sonnet-4-6' ? 'medium' : 'high',
    };
  }

  return {
    supportsThinking: false,
    supportsEffort: false,
    thinkingDefault: null,
    effortLevels: [],
    defaultEffort: null,
  };
}

export function defaultAnthropicLlmOptionsForModel(model) {
  const caps = THINKING_EFFORT_MODELS[model];
  if (!caps) return null;
  return {
    thinking: caps.thinkingDefault,
    effort: caps.defaultEffort,
  };
}

export function defaultThinkingEffortForModel(model) {
  const defaults = defaultAnthropicLlmOptionsForModel(model);
  if (!defaults) return null;
  return {
    classifierThinking: defaults.thinking,
    classifierEffort: defaults.effort,
  };
}
